(() => {
  if (window.DeviemWristSizingInitialized) return;
  window.DeviemWristSizingInitialized = true;

  const groupForForm = (form) => {
    const formId = form?.getAttribute('id');
    if (!formId) return null;
    return document.querySelector(
      `[data-deviem-wrist-selector][data-deviem-form-id="${CSS.escape(formId)}"]`
    );
  };

  const enableAddButton = (container) => {
    const formId = container?.dataset.deviemFormId;
    if (!formId) return;

    const form = document.getElementById(formId);
    const button = form?.querySelector('[data-deviem-awaiting-size]');
    if (!button) return;

    button.disabled = false;
    button.removeAttribute('data-deviem-awaiting-size');
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const container = groupForForm(form);
      const selected = container?.querySelector('[data-deviem-size-input]:checked');
      if (!container || selected) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const inputs = container.querySelectorAll('[data-deviem-size-input]');
      const error = container.querySelector('[data-deviem-wrist-error]');
      inputs.forEach((input) => input.setAttribute('aria-invalid', 'true'));
      if (error) error.hidden = false;
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => inputs[0]?.focus({ preventScroll: true }), 250);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-deviem-size-input]');
    if (!input) return;

    const container = input.closest('[data-deviem-wrist-selector]');
    const error = container?.querySelector('[data-deviem-wrist-error]');
    container
      ?.querySelectorAll('[data-deviem-size-input]')
      .forEach((item) => item.removeAttribute('aria-invalid'));
    if (error) error.hidden = true;
    enableAddButton(container);
  });
})();
